import {create} from 'zustand';
import type {IPublicProperty} from '../schema/publicProperty';

interface PublicPropertiesState {
	publicProperties: IPublicProperty[];
	get: <Bool extends boolean = false>(
		pref: string,
		asBoolean?: Bool,
	) => Bool extends true ? boolean : string | null | undefined;
}

export const usePublicPropertiesStore = create<PublicPropertiesState>()(
	(set, get) => ({
		publicProperties: [],
		get: <Bool extends boolean = false>(pref: string, asBoolean?: Bool) => {
			let publicProperty: string | boolean | null = !pref
				? null
				: (get().publicProperties.find((p) => p.label === pref)?.value ?? null);
			if (asBoolean === true)
				publicProperty = publicProperty?.toLowerCase() === 'true';
			return publicProperty as Bool extends true
				? boolean
				: string | null | undefined;
		},
	}),
);
